import useSEO from "../hooks/useSEO";
import { Mail, Clock, MessageSquare } from "lucide-react";
import PageHero from "../components/PageHero";
import ContactForm from "../components/ContactForm";
import FAQ from "../components/FAQ";
import { Reveal } from "../lib/motion";

export default function Contact() {
  useSEO({
    title: "Contact | SefKam Digital Solutions",
    description: "Have an idea? Let's build it. Tell us what you're trying to build, automate, or improve.",
    path: "/contact",
  });
  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Have an idea? Let's build it."
        subtitle="Tell us what you're trying to build, automate, or improve — and we'll get back to you."
      />

      <section className="bg-white py-24 md:py-32" data-testid="contact-section">
        <div className="container-x grid gap-12 lg:grid-cols-[1fr_1.3fr]">
          <div>
            <Reveal>
              <span className="overline text-slate-400">Reach us</span>
            </Reveal>
            <Reveal delay={0.08}>
              <a href="mailto:contact@sefkam.com" className="mt-4 flex items-center gap-4 rounded-2xl border border-slate-200 bg-[#F8FAFC] p-5 transition-colors hover:border-[#07111F]" data-testid="contact-email-card">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-[#07111F] text-cyan-300"><Mail size={18} /></span>
                <div>
                  <p className="text-xs text-slate-400">Email</p>
                  <p className="text-sm font-semibold text-[#07111F]">contact@sefkam.com</p>
                </div>
              </a>
            </Reveal>
            <div className="mt-4 space-y-4">
              {[[Clock, "Response time", "We typically reply within 1–2 business days."],
                [MessageSquare, "What to include", "A short note on your goal, timeline and context helps us respond well."]].map(([Icon, t, d], i) => (
                <Reveal key={t} delay={0.12 + i * 0.06}>
                  <div className="flex items-start gap-4 rounded-2xl border border-slate-200 p-5">
                    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#07111F] text-cyan-300"><Icon size={18} /></span>
                    <div>
                      <p className="text-sm font-semibold text-[#07111F]">{t}</p>
                      <p className="mt-1 text-sm leading-relaxed text-slate-500">{d}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal delay={0.1}>
            <ContactForm />
          </Reveal>
        </div>
      </section>

      <FAQ />
    </>
  );
}
